import { Field, TextInput, SectionCard } from "./_shared";

export default function EditTracking({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  return (
    <SectionCard title="Rastreamento (Analytics & Pixels)">
      <div className="space-y-5">
        <Field label="Google Analytics ID (G-XXXXXXXXXX)" hint="Obtenha em analytics.google.com">
          <TextInput value={value.googleAnalyticsId} onChange={(v) => set("googleAnalyticsId", v)} testId="tracking-ga-input" />
        </Field>
        <Field label="Facebook Pixel ID" hint="Obtenha em business.facebook.com/events_manager">
          <TextInput value={value.facebookPixelId} onChange={(v) => set("facebookPixelId", v)} testId="tracking-fb-input" />
        </Field>
        <Field label="Google Tag Manager ID (GTM-XXXX)">
          <TextInput value={value.googleTagManagerId} onChange={(v) => set("googleTagManagerId", v)} testId="tracking-gtm-input" />
        </Field>
        <p className="text-xs text-onyx/40">
          Deixe em branco para desativar. Os scripts são injetados automaticamente quando há ID configurado.
        </p>
      </div>
    </SectionCard>
  );
}
